import { DOCUMENT } from "@angular/common";
import { inject, Injectable } from "@angular/core";
import { Confirmation, ToastMessageOptions } from "primeng/api";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class AppService {
  private toastSubject = new BehaviorSubject<ToastMessageOptions|null>(null);
  public toast = this.toastSubject.asObservable();
  private dialogSubject = new BehaviorSubject<Confirmation|null>(null);
  public dialog = this.dialogSubject.asObservable();
  private themeSubject = new BehaviorSubject<string|null>(null);
  public theme = this.themeSubject.asObservable();
  private document = inject(DOCUMENT);

  public showToast(message: ToastMessageOptions) {
    this.toastSubject.next(message);
  }

  public showDialog(dialog: Confirmation) {
    this.dialogSubject.next(dialog);
  }

  public switchTheme(theme: string) {
    const htmlElement = this.document.querySelector('html');

    if (theme === 'theme-dark') {
      htmlElement?.classList.add('beo-app-dark');
    } else {
      htmlElement?.classList.remove('beo-app-dark');
    }
    this.themeSubject.next(theme);
    localStorage.setItem('beoexpo_theme', theme);
  }

}